<template>
  <!-- 调研留言管理 -->
  <div class="page-container">
    <!-- 导航栏 -->
    <!-- 数据卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="6">
            <span style="padding-right: 20px"> 留言总数（共{{ aSum }}条）</span>
          </el-col>
          <el-col :span="6">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 表格内容 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80px"></el-table-column>

          <el-table-column prop="wx_user" label="微信ID" width="100px"></el-table-column>
          <el-table-column prop="message" label="留言内容"></el-table-column>
          <el-table-column
            prop="create_time"
            label="留言时间"
            width="160"
            sortable
          ></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "cnThaList",
  data() {
    return {
      tableData: [],
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
      currentPage: 1,
      aSum: 0,
      input: "",
    };
  },
  mounted() {
    // 页面加载时获取数据
    this.getData();
  },
  methods: {
    // 获取调研留言列表数据
    getData() {
      let url = this.baseUrl + "/admin/survey_message/?type=2";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },
    // 搜索调研留言
    serach() {
      let url = this.baseUrl + "/admin/survey_message/?type=2&search=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url =
        this.baseUrl + "/admin/survey_message/?type=2&page=" + val + "&search=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除调研留言
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/survey_message/" + a_id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .vue-html5-editor > .content {
  max-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/survey_message.vue